import { observer } from "mobx-react";
import React, { PropsWithChildren } from "react";

export const PageHeader = observer((props: PropsWithChildren<{}>) => {
    return <div className="page-header">
        <h1 className="container">{props.children}</h1>
    </div>
})